module.exports = __webpack_public_path__ + "media/images/loghi/icon_monitor-4cfb30fc39070d961dda8c6f095724ae.svg";